import { Component } from "@angular/core";
import { Params } from "@angular/router";
import { RouterService } from "@app/root-store/router.service";
import { Observable } from "rxjs";

@Component({
    selector: "app-copyright-block",
    templateUrl: "./copyright-block.component.html",
    styleUrls: ["./copyright-block.component.css"],
})
export class CopyrightBlockComponent {
    public year = new Date().getFullYear();
    public queryParams$: Observable<Params> = this.routerService.getQueryParams();

    constructor(private readonly routerService: RouterService) {}
}
